module.exports = __webpack_public_path__ + "img/h5_banner.36abac18.png";